window.addEventListener("DOMContentLoaded", () => {
  try {
    // Only trigger when ?customise=1 is in the URL
    const shouldLaunch = window.location.search.includes("customise=1");

    if (!shouldLaunch) return; // STOP here unless customiser was requested

    // Kickflip must exist AND must use customize_button integration
    if (
      typeof kickflip !== "undefined" &&
      kickflip.integrationSettings &&
      kickflip.integrationSettings.integration_type === "customize_button"
    ) {
      // auto-click hidden Kickflip button
      setTimeout(() => {
        const hiddenBtn = document.querySelector("#kickflip-customize-button");
        if (hiddenBtn) hiddenBtn.click();
      }, 600); // shorter delay works fine

      // Optional UI adjustments
      setTimeout(() => {
        document.querySelector(".cta-btn")?.classList.remove("hide");
        document.querySelector(".loader")?.classList.add("hide");

        const customiseEl = document.querySelector("customize-button");
        if (customiseEl) customiseEl.textContent = "Customize";
      }, 1500);
    }
  } catch (err) {
    console.warn("Kickflip autolaunch failed:", err);
  }
});
